import { render, staticRenderFns } from "./AnexosOcorrencia.vue?vue&type=template&id=cc4604b6"
import script from "./AnexosOcorrencia.vue?vue&type=script&lang=js"
export * from "./AnexosOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./AnexosOcorrencia.vue?vue&type=style&index=0&id=cc4604b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports